import {
  faTimes,
  faPlus,
  faFile,
  faEllipsisVertical,
  faPenToSquare,
  faTrash,
  faCopy,
  faClipboard,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import {
  Popover,
  PopoverAnchor,
  PopoverContent,
  SelectInput,
  TextareaInput,
  TextInput,
  ToggleInput,
} from "../../input";
import { generateKey } from "../../input/generateID";
import { GrigoraEditorContext } from "../context";
import slugify from "slugify";
import { makeID, remove_prefix } from "../../helpers";
import { motion } from "framer-motion";
import { ModalInput } from "../../ui-kit";
import { INPUT_LIMITS } from "../../input-limits";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { WhiteLabelContext } from "../../whitelabel";
const PageComponent = (props) => {
  const [toggle, setToggle] = useState(false);
  const [editPageModal, setEditPageModal] = useState(false);
  const { page } = props;

  const {
    pagesData,
    currentPage,
    setLeftWidget,
    changeCurrentPage,
    deletePage,
    duplicatePage,
    setPrevPage,
  } = useContext(GrigoraEditorContext);

  return (
    <>
      <div
        key={`page-switch-${page}`}
        onClick={() => {
          if (page !== currentPage) {
            changeCurrentPage(page);
            setPrevPage(currentPage);
          }
          setLeftWidget("");
        }}
        className={`grigora-page-tile border border-transparent hover:border-ui-dark-blue duration-200 page-${page} bg-white cursor-pointer relative px-4 py-3 pr-0 rounded-[8px] mb-2 flex gap-2 items-center ${
          page === currentPage ? "active" : ""
        }`}
      >
        {/* <FontAwesomeIcon className="mb-[2px]" icon={faFile} size="xs" /> */}
        <span
          className="text-ellipsis truncate whitespace-nowrap"
          title={pagesData[page]?.name}
        >
          {pagesData[page]?.type === "template" ? (
            <>
              <span
                className="p-1 inline-flex justify-center items-center w-[20px] h-[20px] text-[10px] bg-purple-100 border border-purple-200 rounded-full mr-2"
                title={`Template${
                  pagesData[page]?.template
                    ? `: ${pagesData[page]?.template}`
                    : ``
                }`}
              >
                T
              </span>
            </>
          ) : null}
          {pagesData[page]?.name}
        </span>
        <div className="ml-auto px-2">
          <Popover open={toggle} onOpenChange={setToggle} placement="right">
            <PopoverAnchor
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setToggle(!toggle);
              }}
            >
              <span
                className={`ml-auto px-2 rounded-full border border-transparent hover:border-purple-500 duration-200 hover:bg-purple-200 ${
                  toggle ? "bg-purple-200 border-purple-500" : ""
                }`}
              >
                <FontAwesomeIcon icon={faEllipsisVertical} size="sm" />
              </span>
            </PopoverAnchor>
            <PopoverContent
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              className="!z-[10000] !rounded-[6px] !bg-white !shadow-editor-floating-elements"
            >
              <div className="p-3 w-28">
                <button
                  onClick={() => setEditPageModal(!editPageModal)}
                  className="p-1 outline-none border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white rounded w-full mb-2 text-grigora-base text-left"
                >
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    size="xs"
                    className="mr-1 ml-1"
                  />{" "}
                  Edit
                </button>
                {/* <button className="p-1 border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white rounded w-full mb-2 text-xs text-left">
                  <FontAwesomeIcon icon={faClipboard} size="xs" className="mr-1 ml-1" /> Copy
                </button> */}
                <button
                  onClick={() => {
                    duplicatePage(page);
                  }}
                  className="p-1 border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white rounded w-full mb-2 text-xs text-left"
                >
                  <FontAwesomeIcon
                    icon={faCopy}
                    size="xs"
                    className="mr-1 ml-1"
                  />{" "}
                  Duplicate
                </button>
                {pagesData[page].slug !== "" ? (
                  <>
                    {pagesData[page].type === "template" &&
                    pagesData[page].template === "directory-template" ? (
                      <></>
                    ) : (
                      <>
                        <br />
                        <button
                          onClick={() => {
                            deletePage(page);
                          }}
                          className="p-1 border border-red-500 text-red-500 hover:bg-red-500 hover:text-white rounded w-full text-grigora-base text-left"
                        >
                          <FontAwesomeIcon
                            icon={faTrash}
                            size="xs"
                            className="mr-1 ml-1"
                          />{" "}
                          Delete
                        </button>
                      </>
                    )}
                  </>
                ) : null}
              </div>
            </PopoverContent>
          </Popover>
        </div>
      </div>
      <EditPage state={editPageModal} setState={setEditPageModal} page={page} />
    </>
  );
};

const EditPage = (props) => {
  const { state, setState, page } = props;
  const { project, pagesData, updatePageData } =
    useContext(GrigoraEditorContext);
  const [formPage, setFormPage] = useState(pagesData[page]);
  const { directoryTypes } = useContext(GrigoraDashboardContext) ?? {};

  const { __whitelabel_website_publishing_domain__ } =
    useContext(WhiteLabelContext) ?? {};

  return (
    <ModalInput
      isOpened={state}
      onOutsideClick={() => {
        setState(false);
      }}
    >
      <div className="bg-white rounded-[21px] grigora-add-new-page gap-2 grigora-hidden-scrollbar flex flex-col mw-[50pw] mh-[80vh] w-[50vw] h-[60vh] p-5 cursor-default">
        <div className="modal-heading mb-4">Edit Page</div>
        <div className="overflow-y-auto grigora-hidden-scrollbar pr-2">
          <div className="grigora-add-new-page__form-name text-sm mb-2">
            <div className="mb-2">Page Name</div>
            <TextInput
              minLength={INPUT_LIMITS["page-name"].minlength}
              maxLength={INPUT_LIMITS["page-name"].maxlength}
              isResetVisible={false}
              value={formPage.name}
              onChange={(val) => {
                setFormPage({ ...formPage, name: val });
              }}
            />
          </div>
          <div className="flex gap-[20px] grigora-add-new-page__form-name text-sm mb-2">
            <div className="mb-2">Is This Page A Template?</div>
            <ToggleInput
              isResetVisible={false}
              value={formPage.type === "template"}
              onChange={(val) => {
                if (val) {
                  setFormPage({
                    ...formPage,
                    type: "template",
                    template: "other",
                  });
                } else {
                  setFormPage({ ...formPage, type: "", template: "" });
                }
              }}
            />
          </div>
          {formPage.type === "template" ? (
            <>
              <div className="grigora-add-new-page__form-name text-sm mb-2">
                <div className="mb-2">Select Template Type</div>
                <SelectInput
                  isResetVisible={false}
                  value={formPage.template}
                  onChange={(val) => {
                    setFormPage({ ...formPage, template: val });
                  }}
                  options={[
                    {
                      value: "cms-post",
                      label: "CMS Post",
                    },
                    {
                      value: "cms-category",
                      label: "CMS Category",
                    },
                    {
                      value: "cms-author",
                      label: "CMS Author",
                    },
                    {
                      value: "directory-template",
                      label: "Directory Template",
                    },
                    {
                      value: "other",
                      label: "Other",
                    },
                  ]}
                />
              </div>
              {formPage.template === "directory-template" ? (
                <>
                  <div className="grigora-add-new-page__form-name text-sm mb-2">
                    <div className="mb-2">Directory</div>
                    <SelectInput
                      isResetVisible={false}
                      value={formPage.directory_id}
                      onChange={(val) => {
                        setFormPage({ ...formPage, directory_id: val });
                      }}
                      options={[
                        ...directoryTypes?.map((type) => ({
                          label: type.name,
                          value: remove_prefix(type.sk, "directory-type-"),
                        })),
                      ]}
                    />
                  </div>
                </>
              ) : null}
            </>
          ) : (
            <>
              <div className="grigora-add-new-page__form-permalink text-sm mb-2">
                <div className="mb-2">Permalink</div>
                <TextInput
                  minLength={INPUT_LIMITS["page-permalink"].minlength}
                  maxLength={INPUT_LIMITS["page-permalink"].maxlength}
                  isResetVisible={false}
                  value={formPage.slug}
                  onChange={(val) => {
                    setFormPage({
                      ...formPage,
                      slug: slugify(val, {
                        trim: false,
                        strict: true,
                        lower: true,
                      }),
                    });
                  }}
                />
                <div className="text-grigora-base text-editor-text-main">
                  {project.slug +
                    "." +
                    __whitelabel_website_publishing_domain__() +
                    "/" +
                    (formPage.slug ? formPage.slug + "/" : "")}
                </div>
              </div>
              <div className="grigora-add-new-page__form-name text-sm mb-2">
                <div className="mb-2">Page Title</div>
                <TextInput
                  minLength={INPUT_LIMITS["page-title"].minlength}
                  maxLength={INPUT_LIMITS["page-title"].maxlength}
                  isResetVisible={false}
                  value={formPage.title}
                  onChange={(val) => {
                    setFormPage({ ...formPage, title: val });
                  }}
                />
              </div>
              <div className="grigora-add-new-page__form-name text-sm mb-2">
                <div className="mb-1">Page SEO Title</div>
                <TextInput
                  minLength={INPUT_LIMITS["page-title"].minlength}
                  maxLength={INPUT_LIMITS["page-title"].maxlength}
                  isResetVisible={false}
                  value={formPage.seo_meta_title}
                  placeholder={formPage.title ?? ""}
                  onChange={(val) => {
                    setFormPage({ ...formPage, seo_meta_title: val });
                  }}
                />
              </div>
              <div className="grigora-add-new-page__form-name text-sm mb-2">
                <div className="mb-2">Page Meta Description</div>
                <TextareaInput
                  minLength={INPUT_LIMITS["seo-meta-description"].minlength}
                  maxLength={INPUT_LIMITS["seo-meta-description"].maxlength}
                  isResetVisible={false}
                  value={formPage.seo_meta_desc}
                  onChange={(val) => {
                    setFormPage({ ...formPage, seo_meta_desc: val });
                  }}
                />
              </div>
            </>
          )}
        </div>
        <div className="mt-auto">
          <div className="grigora-add-new-page__btns text-sm flex gap-[10px] justify-end ">
            <div
              onClick={() => {
                updatePageData(
                  page,
                  formPage.name,
                  formPage.title,
                  formPage.slug,
                  formPage.seo_meta_desc,
                  formPage.type,
                  formPage.template,
                  formPage.seo_meta_title,
                );
                setState(false);
              }}
              className="grigora-action-btn"
            >
              Update
            </div>
          </div>
        </div>
      </div>
    </ModalInput>
  );
};

const PagesSwitcher = () => {
  const { pagesData, setLeftWidget, project, addNewPage } =
    useContext(GrigoraEditorContext);

  const [addNewPageModal, setAddNewPageModal] = useState(false);
  const [formPage, setFormPage] = useState({});

  // Group pages into normal and template pages
  const normalPages = Object.keys(pagesData).filter(
    (page) => !pagesData[page]?.type || pagesData[page]?.type !== "template",
  );
  const templatePages = Object.keys(pagesData).filter(
    (page) => pagesData[page]?.type === "template",
  );

  const { __whitelabel_website_publishing_domain__ } =
    useContext(WhiteLabelContext) ?? {};

  return (
    <>
      <motion.div
        initial={{ x: -400 }}
        animate={{ x: 0 }}
        exit={{ x: -400 }}
        transition={{ duration: 0.3, delay: 0 }}
        key="pages"
        style={{
          clipPath: "inset(0px -200vw -100vh 0px)",
        }}
        className="bg-white border-l border-t shadow-editor-floating-elements z-[-1] w-[400px] text scroll-auto select-none"
      >
        <div className="h-10 w-[400px] border-b flex px-5 items-center">
          <h4 className="text-[14px] w-full font-medium flex items-center justify-between">
            Pages
            <span
              onClick={() => {
                setLeftWidget("");
              }}
              className="float-right cursor-pointer duration-200 w-[25px] h-[25px] flex items-center justify-center rounded-full hover:bg-gray-100"
            >
              <FontAwesomeIcon icon={faTimes} />
            </span>
          </h4>
        </div>
        <div className="grigora-left-sidebar__pages text-grigora-base">
          <div className="overflow-y-auto h-[80vh] p-2">
            {/* Normal Pages */}
            {normalPages.length > 0 && (
              <div className="mb-4">
                <h5 className="text-[12px] font-medium text-gray-500 mb-2 px-2">
                  Pages
                </h5>
                {normalPages.map((page) => (
                  <PageComponent key={page} page={page} />
                ))}
              </div>
            )}

            {/* Template Pages */}
            {templatePages.length > 0 && (
              <div className="mb-4">
                <h5 className="text-[12px] font-medium text-gray-500 mb-2 px-2">
                  Template Pages
                </h5>
                {templatePages.map((page) => (
                  <PageComponent key={page} page={page} />
                ))}
              </div>
            )}
          </div>
          <div
            onClick={() => {
              setFormPage({
                name: "Untitled",
                slug: "untitled-" + makeID(5),
                title: "Untitled",
              });
              setAddNewPageModal(true);
            }}
            className={`grigora-page-tile bg-white p-2 flex gap-2 items-center justify-center cursor-pointer mt-6 rounded-[6px] w-[80%] mx-auto hover:border-purple-400 border-[1px] duration-300 text-grigora-base`}
          >
            <FontAwesomeIcon icon={faPlus} size="xs" />
            Add Page
          </div>
        </div>
      </motion.div>
      <ModalInput
        isOpened={addNewPageModal}
        onOutsideClick={(e) => {
          setAddNewPageModal(false);
        }}
      >
        <div className="bg-white rounded-[21px] grigora-add-new-page gap-2 grigora-hidden-scrollbar flex flex-col mw-[50pw] mh-[80vh] w-[50vw] h-[60vh] p-5 cursor-default">
          <div className="modal-heading mb-4">Add New Page</div>
          <div className="overflow-y-auto grigora-hidden-scrollbar pr-2">
            <div className="grigora-add-new-page__form-name text-sm mb-3">
              <div className="mb-2">Page Name</div>
              <TextInput
                minLength={INPUT_LIMITS["page-name"].minlength}
                maxLength={INPUT_LIMITS["page-name"].maxlength}
                value={formPage.name}
                onChange={(val) => {
                  setFormPage({ ...formPage, name: val });
                }}
                isResetVisible={false}
              />
            </div>
            <div className="flex gap-[20px] grigora-add-new-page__form-name text-sm mb-2">
              <div className="mb-2">Is This Page A Template?</div>
              <ToggleInput
                value={formPage.type === "template"}
                onChange={(val) => {
                  if (val) {
                    setFormPage({
                      ...formPage,
                      type: "template",
                      template: "other",
                    });
                  } else {
                    setFormPage({ ...formPage, type: "", template: "" });
                  }
                }}
              />
            </div>
            {formPage.type === "template" ? (
              <>
                <div className="grigora-add-new-page__form-name text-sm mb-2">
                  <div className="mb-2">Select Template Type</div>
                  <SelectInput
                    isResetVisible={false}
                    value={formPage.template}
                    onChange={(val) => {
                      setFormPage({ ...formPage, template: val });
                    }}
                    options={[
                      {
                        value: "cms-post",
                        label: "CMS Post",
                      },
                      {
                        value: "cms-category",
                        label: "CMS Category",
                      },
                      {
                        value: "cms-author",
                        label: "CMS Author",
                      },
                      {
                        value: "other",
                        label: "Other",
                      },
                    ]}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="grigora-add-new-page__form-permalink text-sm mb-2">
                  <div className="mb-2">Permalink</div>
                  <TextInput
                    minLength={INPUT_LIMITS["page-permalink"].minlength}
                    maxLength={INPUT_LIMITS["page-permalink"].maxlength}
                    value={formPage.slug}
                    isResetVisible={false}
                    onChange={(val) => {
                      setFormPage({
                        ...formPage,
                        slug: slugify(val, {
                          trim: false,
                          strict: true,
                          lower: true,
                        }),
                      });
                    }}
                  />
                  <div className="text-grigora-base text-editor-text-main">
                    {project.slug +
                      "." +
                      __whitelabel_website_publishing_domain__() +
                      "/" +
                      (formPage.slug ? formPage.slug + "/" : "")}
                  </div>
                </div>
                <div className="grigora-add-new-page__form-name text-sm mb-2">
                  <div className="mb-2">Page Title</div>
                  <TextInput
                    minLength={INPUT_LIMITS["page-title"].minlength}
                    maxLength={INPUT_LIMITS["page-title"].maxlength}
                    isResetVisible={false}
                    value={formPage.title}
                    onChange={(val) => {
                      setFormPage({ ...formPage, title: val });
                    }}
                  />
                </div>
                <div className="grigora-add-new-page__form-name text-sm mb-2">
                  <div className="mb-1">Page SEO Title</div>
                  <TextInput
                    minLength={INPUT_LIMITS["page-title"].minlength}
                    maxLength={INPUT_LIMITS["page-title"].maxlength}
                    isResetVisible={false}
                    value={formPage.seo_meta_title}
                    placeholder={formPage.title ?? ""}
                    onChange={(val) => {
                      setFormPage({ ...formPage, seo_meta_title: val });
                    }}
                  />
                </div>
                <div className="grigora-add-new-page__form-name text-sm mb-2">
                  <div className="mb-2">Page Meta Description</div>
                  <TextareaInput
                    minLength={INPUT_LIMITS["seo-meta-description"].minlength}
                    maxLength={INPUT_LIMITS["seo-meta-description"].maxlength}
                    isResetVisible={false}
                    value={formPage.seo_meta_desc}
                    onChange={(val) => {
                      setFormPage({ ...formPage, seo_meta_desc: val });
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <div className="mt-auto">
            <div className="grigora-add-new-page__btns text-sm flex gap-[10px] justify-end ">
              <div
                onClick={() => {
                  addNewPage(formPage).then(() => {
                    setAddNewPageModal(false);
                  });
                }}
                className="grigora-action-btn"
              >
                Add New Page
              </div>
            </div>
          </div>
        </div>
      </ModalInput>
    </>
  );
};

export default PagesSwitcher;
